import { JSX } from 'react';
import { BenefitsProvider } from './BenefitsContext';
import { CartProvider } from './CartContext';
import { PlatformInfoProvider } from './PlatformInfoContext';
import { CarouselsProvider } from './CarouselsProvider';

export const AuthenticatedBenefitContextsProviders = (props: {
  children: JSX.Element;
}) => {
  return (
    <BenefitsProvider>
      <PlatformInfoProvider>
        <CarouselsProvider>
          <CartProvider>{props.children}</CartProvider>
        </CarouselsProvider>
      </PlatformInfoProvider>
    </BenefitsProvider>
  );
};
